import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useIsoLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export function scrollToTopInstant() {
  const html = document.documentElement;
  const previousBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';

  window.scrollTo(0, 0);
  html.scrollTop = 0;
  document.body.scrollTop = 0;

  const main = document.getElementById('main-content');
  if (main) {
    main.scrollTop = 0;
  }

  html.style.scrollBehavior = previousBehavior;
}

/**
 * Jump to the top on every path change. Needed because React Router keeps
 * the previous scroll offset, and html { scroll-behavior: smooth } would
 * otherwise animate from the footer after a legal-link click.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useIsoLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    if (hash) return;

    scrollToTopInstant();

    const frame = window.requestAnimationFrame(() => {
      scrollToTopInstant();
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
